import type {
  CommandExcludedServiceSlotId,
  CommandHandlerContext,
  CommandKey,
} from '@learnitive/types';

export const commandExcludedServices = [
  'commandRegistry',
  'commandDispatcher',
] as const satisfies CommandExcludedServiceSlotId[];

export const commandKeyToContext: WeakMap<
  CommandKey<string>,
  { context: CommandHandlerContext }
> = new WeakMap();
